import { lang } from 'store/lang.store'
import axios from 'axios'

const csrf = window.context.csrf

const API_HEADER = {
  post: {
    'X-CSRFTOKEN': csrf,
  },
  'X-CSRFToken': csrf,
  'Accept-Language': lang.value,
}

const instance = axios.create({
  baseURL: '/',
  withCredentials: true,
  headers: API_HEADER,
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFTOKEN',
  cache: false,
})

const api = instance

api.interceptors.request.use(
  function requestMethod(config) {
    if (config.method !== 'get') {
      api?.storage?.clear()
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

const URLS = {
  reports_summary: '/copa/api/reports/summary/',
  reports_overview: '/copa/api/reports/overview/',
  reports_evolution: '/copa/api/reports/evolution/',
  reports_enablers: '/copa/api/reports/enablers/',
  reports_quick_wins: '/copa/api/reports/quick-wins/',
  reports_highlights: '/copa/api/reports/highlights/',
  reports_pilar: '/copa/api/reports/pilar/',

  zones: '/copa/api/filters/zones/',
  bottlers: '/copa/api/filters/bottlers/',
  copa_auth: '/copa/api/auth/',
  copa_tiers: '/copa/api/filters/tiers/',
}

export { api, URLS, API_HEADER }
